/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The result of compiling a single CEL expression for the editor.
 */
export type ExprCompileResult = {
  /**
   * Compiler error message when ok is false; empty otherwise.
   */
  error: string;
  /**
   * True when the expression compiled successfully.
   */
  ok: boolean;
};

/** @internal */
export const ExprCompileResult$inboundSchema: z.ZodMiniType<
  ExprCompileResult,
  unknown
> = z.object({
  error: z.string(),
  ok: z.boolean(),
});

export function exprCompileResultFromJSON(
  jsonString: string,
): SafeParseResult<ExprCompileResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExprCompileResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExprCompileResult' from JSON`,
  );
}
